<template>
  <div class="sub-video-clip-list">
    <div class="sub-video-clip-title">
      <span>添加片段</span>
      <div
        @click="handleShowSubVideoClipList(false)"
        class="icon iconfont icon-close"
      ></div>
    </div>
    <a-tabs v-model="type" class="sub-video-clip-type">
      <a-tab-pane key="3,11" tab="视频片段" />
      <a-tab-pane key="4,7" tab="片头片尾" />
    </a-tabs>
    <div class="video-clip-search-close">
      <label class="video-clip-search">
        <a-input-search
          class="video-clip-search__input"
          placeholder="请输入搜索关键字"
          @search="handleSearch"
          @change="callWatch"
          v-model="tempKeyword"
        />
      </label>
      <!-- <a-radio-group
        v-model="fragmentType"
        v-if="type === '3,11'"
        button-style="solid"
      >
        <a-radio-button value="">全部</a-radio-button>
        <a-radio-button
          :value="item.value"
          :key="item.value"
          v-for="item in fragmentTypeList"
        >
          {{ item.name }}
        </a-radio-button>
      </a-radio-group> -->
    </div>

    <div class="video-clip-custom-list">
      <div
        class="video-clip-custom-group"
        v-if="type === '3,11' && showSubVideoClipList !== 'replace'"
      >
        <div @click="handleAdd" class="video-clip-custom-img-white">
          <span class="icon iconfont icon-close"></span>
        </div>
        <div class="video-clip-custom-title">自定义片段</div>
      </div>

      <div
        :key="item.id"
        @click="handleAddTemplate(item.id, item.type)"
        @mouseenter="showPreview(item)"
        @mouseleave="closePreview()"
        class="video-clip-custom-group"
        v-for="item in templateList"
      >
        <span
          @click.stop="starClick(item)"
          class="tem_used_icon"
          :class="{ block: item.is_collect }"
          :title="item.is_collect ? '取消收藏' : '收藏'"
          :style="{
            'background-image': item.is_collect
              ? 'url(/preview/icon/icon_collected.png)'
              : 'url(/preview/icon/icon_collect.png)'
          }"
        ></span>
        <img
          v-if="item.thumbnail"
          :src="item.thumbnail + '?x-oss-process=image/resize,w_320'"
          alt="Fragment Preview"
          class="video-clip-custom-img"
        />
        <img
          v-else
          class="video-clip-custom-img"
          src="//aivideo8.oss-cn-hongkong.aliyuncs.com/ai_video/U71-2020-05-08-img-1588927160629.png?x-oss-process=image/resize,w_216"
        />
        <button class="video-clip-preview" type="button">
          <span class="icon iconfont icon-preview"></span>
        </button>
        <div :title="item.name" class="video-clip-custom-title">
          {{ item.name }}
        </div>
      </div>
      <a-spin spinning v-show="loading" class="video-clip-custom-group">
        <div class="video-clip-custom-img" />
        <div class="video-clip-custom-title">Loading</div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import watchThrottle from '../../utils/watch-throttle';

export default {
  name: "SubVideoClipList",
  data() {
    return {
      keyword: '',
      tempKeyword: '',
      loading: false,
      type: '3,11',
      fragmentType: ''
    }
  },
  computed: {
    ...mapState(['templateList', 'showSubVideoClipList', 'fragmentTypeList']),
    templateMarker() {
      return [this.keyword, this.type, (this.type === '3,11' ? this.fragmentType : '')].join(',');
    }
  },
  methods: {
    ...mapMutations(['handleShowSubVideoClipList']),
    ...mapActions(['addFragment', 'getTemplateDetail', 'delCollect', 'addCollect']),
    handleAdd() {
      this.addFragment();
    },
    handleAddTemplate(id, type) {
      this.getTemplateDetail({ id, type });
    },
    handleSearch() {
      this.queryLock();
    },
    callWatch() {
      this.queryWatch();
    },
    async getTemplateList() {
      this.loading = true;
      if (await this.$store.dispatch('getTemplateList', {
        keyword: this.keyword,
        type: this.type.split(','),
        fragmentType: this.type === '3,11' ? this.fragmentType : ''
      })) {
        this.loading = false;
      }
    },
    showPreview(item) {
      this.previewTimer && clearTimeout(this.previewTimer);
      this.$store.commit("handlePreviewTemplate", item);
    },
    closePreview() {
      this.previewTimer = setTimeout(() => {
        this.$store.commit("handlePreviewTemplate", null);
      }, 1e3)
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'fragment', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'fragment', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
  },
  created() {
    const { watch, lock } = watchThrottle(() => {
      this.keyword = this.tempKeyword;
    });
    this.queryWatch = watch;
    this.queryLock = lock;
  },
  watch: {
    templateMarker() {
      if (this.showSubVideoClipList) {
        this.getTemplateList();
      }
    },
    showSubVideoClipList(val) {
      if (val) {
        this.tempKeyword = '';
        if (this.keyword || this.type !== '3,11' || this.fragmentType) {
          this.keyword = '';
          this.type = '3,11';
          this.fragmentType = '';
        } else {
          this.getTemplateList();
        }
      }
    }
  }
}
</script>

<style scoped>
.video-clip-custom-group:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.sub-video-clip-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sub-video-clip-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px 0;
}
.video-clip-search-close,
.video-clip-custom-img-white {
  display: flex;
  margin-top: 18px;
}

.video-clip-search-close {
  padding: 0 20px 8px;
  flex-direction: column;
}

.icon {
  font-size: 22px;
  cursor: pointer;
}

.video-clip-search {
  flex-grow: 1;
  /* margin-bottom: 12px; */
}

.video-clip-search__input {
  height: 41px;
}

.video-clip-search__icon {
  color: rgba(0, 0, 0, 0.3);
}

.video-clip-custom-list {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  padding: 16px 20px 0;
  justify-content: space-between;
  overflow: auto;
  align-items: flex-start;
  align-content: start;
}

.video-clip-custom-group {
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
}

.video-clip-custom-img-white {
  width: 160px;
  height: 90px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  margin-top: 0;
  align-items: center;
  justify-content: center;
}

.video-clip-custom-img-white .icon {
  font-size: 60px;
  color: #a5a5a5;
  transform: rotate(45deg);
}

.video-clip-custom-img {
  object-fit: cover;
  width: 160px;
  height: 90px;
  border-radius: 6px;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  max-width: 160px;
  margin: 9px auto 0 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-clip-preview {
  position: absolute;
  right: 2px;
  bottom: 36px;
  width: 22px;
  height: 16px;
  background: #0009;
  border-radius: 4px;
  justify-content: center;
  margin: 4px 4px 0 0;
  outline: none;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-preview {
  font-size: 16px;
  color: #fff;
}

.icon-preview:before {
  content: "\e6b9";
}
</style>
<style>
.video-clip-custom-group.ant-spin-nested-loading
  > div
  > .ant-spin
  .ant-spin-dot {
  top: 40%;
}

.video-clip-search__input .ant-input {
  border-radius: 2px;
  height: 100%;
}

.sub-video-clip-type {
  flex-shrink: 0;
  text-align: center;
}

.sub-video-clip-type .ant-tabs-bar {
  margin-bottom: 0;
}

.sub-video-clip-type .ant-tabs-nav {
  display: block;
}

.sub-video-clip-type .ant-tabs-nav > div {
  display: flex;
}

.sub-video-clip-type .ant-tabs-bar .ant-tabs-tab {
  flex-grow: 1;
  margin-right: 0;
}
</style>
